$ = jQuery.noConflict()

$(document).ready(function () {
  const $masthead = $('#masthead')
  const $sandwich = $('.site-header-sandwich')
  const $nav = $('.site-header-nav')
  const $brand = $('#brand')

  if (!$sandwich.length || !$masthead.length) {
    return
  }

  function closeMegaPanels() {
    $('[data-mega].is-open').each(function () {
      const $panel = $(this)
      $panel.removeClass('is-open')
      $panel.find('.ligo-nav__trigger').attr('aria-expanded', 'false')
    })
  }

  function applyLogoForToggle(closing, scrolled) {
    const main = $brand.data('brand')
    const alt = $brand.data('brandtwo')
    // Logo principal solo al cerrar el menú móvil con el header “en reposo” (no scroll actived).
    if (closing && !scrolled) {
      $brand.attr('src', main)
    } else {
      $brand.attr('src', alt)
    }
  }

  $sandwich.on('click', function () {
    const closing = $sandwich.hasClass('active')
    const scrolled = $masthead.hasClass('actived')

    applyLogoForToggle(closing, scrolled)
    closeMegaPanels()

    $masthead.toggleClass('active')
    $sandwich.toggleClass('active')
    $nav.toggleClass('active')

    $sandwich.attr('aria-expanded', $sandwich.hasClass('active') ? 'true' : 'false')
  })

  $sandwich.on('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      $(this).trigger('click')
    }
  })

  $(document).on('keydown.ligoMenuMobile', function (e) {
    if (e.key !== 'Escape' || !$sandwich.hasClass('active')) {
      return
    }
    $sandwich.trigger('click')
  })
})
